export const SOCIALS = [
  { name: "LinkedIn", href: "https://linkedin.com/company/tlastudios", icon: "in" },
];
